<form
  class="details-form"
  [formGroup]="accountDetailForm"
  (ngSubmit)="handleSave()"
>
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="details-card">
    <div class="section-copy">
      <span class="section-kicker">Profile</span>
      <h3>Account Details</h3>
      <p>
        Update your public profile, contact email, phone, and profile image.
      </p>
    </div>

    <div class="form-grid">
      <label class="field">
        <span>Username *</span>

        <div class="username-control">
          <span>gloget.com/</span>
          <input type="text" formControlName="userName" placeholder="sophia" />
        </div>

        @if (isInvalid("userName")) {
          <small>Username is required</small>
        }
      </label>

      <label class="field">
        <span>Email *</span>

        <glo-control
          [value]="accountDetailForm.get('email')?.value"
          (valueChange)="accountDetailForm.get('email')?.patchValue($event)"
          icon="mail"
          placeholder="olivia@example.com"
        >
        </glo-control>

        @if (isInvalid("email")) {
          <small>Valid email is required</small>
        }
      </label>

      <label class="field">
        <span>Phone *</span>

        <glo-control
          [value]="accountDetailForm.get('phone')?.value"
          (valueChange)="accountDetailForm.get('phone')?.patchValue($event)"
          [showIcon]="false"
          placeholder="+1 (555) 000-0000"
        >
        </glo-control>

        @if (isInvalid("phone")) {
          <small>Phone is required</small>
        }
      </label>
    </div>
  </section>

  <section class="details-card">
    <div class="section-copy">
      <span class="section-kicker">Avatar</span>
      <h3>Your Photo</h3>
      <p>This image is displayed on your business account profile.</p>
    </div>

    <div class="photo-row">
      <img
        [src]="preview || assetUrl + 'img/avatar1.png'"
        alt="Profile photo"
        class="profile-photo"
      />

      <div class="photo-copy">
        <strong>Profile Image</strong>
        <span>Upload a square image for best display quality.</span>

        @if (isInvalid("image")) {
          <small>Image is required</small>
        }
      </div>

      <div class="photo-actions">
        <button type="button" class="light-btn" (click)="onDelete($event)">
          Delete
        </button>

        <button type="button" class="dark-btn" (click)="triggerUpload()">
          Update
        </button>

        <input
          type="file"
          #fileInput
          class="hidden"
          accept="image/*"
          (change)="onFileSelected($event)"
        />
      </div>
    </div>
  </section>

  <div class="form-footer">
    <button type="button" class="light-btn" (click)="resetForm()">
      Cancel
    </button>

    <button type="submit" class="dark-btn">Save Changes</button>
  </div>
</form>
